<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-aggre map-marker"
            :class="{ active: active === fmLatlng }"
            @mouseenter="showBoundary"
            @mouseleave="hideBoundary"
            @click="onClick"
            @touchend="onClick"
            v-bind="$attrs"
        >
            <div class="marker-shape">
                <div class="info">
                    <span class="count">{{ data.count }}</span>
                    <span class="label">{{ data.label }}</span>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script>
import Marker from './marker';
import util from '../../../common/util';
import numberFormat from '@/common/format/number-format';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import { getBoundaryColor } from '../../map/common';
export default {
    mixins: [Marker],
    inject: {
        mapTheme: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            type: 'aggre'
        };
    },
    computed: {
        ...mapState(usePageStore, {
            page: store => store.page || {},
            currencySymbol: store => store.currency.symbol
        })
    },
    methods: {
        numberFormat,
        showBoundary() {
            if (this.boundary && !this.platform.isMobile) {
                this.boundary.setVisibility(true);
            } else {
                this.applyMap(([map, maps]) => {
                    let themeColor = getBoundaryColor.call(this, this.mapTheme);
                    const color = {
                        strokeColor: util.colorToRgba(themeColor, 1),
                        fillColor: util.colorToRgba(themeColor, 0.2),
                        lineWidth: 2
                    };
                    const linestring = new window.H.geo.LineString();
                    const linestringArr = [];
                    const boundary = this.data.bounds;
                    boundary.forEach((itemBoundary, index) => {
                        if (util.isArray(itemBoundary)) {
                            if (index === 0) {
                                itemBoundary.forEach(point => {
                                    linestring.pushPoint(point);
                                });
                            } else {
                                const itemLine = new window.H.geo.LineString();
                                itemBoundary.forEach(point => {
                                    itemLine.pushPoint(point);
                                });
                                linestringArr.push(itemLine);
                            }
                        } else {
                            linestring.pushPoint(itemBoundary);
                        }
                    });
                    const geoPolygon = new window.H.geo.Polygon(
                        linestring,
                        linestringArr
                    );
                    this.boundary = new window.H.map.Polygon(geoPolygon, {
                        style: color
                    });
                    map.addObject(this.boundary);
                    this.map = map;
                    this.boundary.setVisibility(true);
                });
            }
            this.onMouseEnter();
        },
        hideBoundary() {
            if (this.boundary) {
                this.boundary.setVisibility(false);
            }
            this.onMouseLeave();
        },
        onClick: util.debounce(function() {
            const clickEvent = this.events && this.events.click;
            if (clickEvent) {
                clickEvent.call(this);
                return this.afterClick();
            }
            this.applyMap(([map, maps, siteMap]) => {
                this.hideBoundary();
                siteMap.aggregationMarkers = [];
                //  mobile terminal ， Click on the aggregation point to add directly 2
                let { lat, lng } = this.data;
                let zoom = map.getZoom();
                if (this.platform.isMobile) {
                    zoom += 2;
                } else {
                    zoom += zoom < 10 ? 3 : zoom <= 16 ? 2 : 1;
                }
                map.getViewModel().setLookAtData(
                    { position: { lat, lng }, zoom },
                    true
                );
            });
            return this.afterClick();
        }, 400),
        afterClick() {
            this.$EventBus.$emit('siteTrack', {
                action: 'aggregation',
                trackType: 'map-event',
                ele: this.$el
            });
        }
    },
    beforeUnmount() {
        if (this.boundary && this.map) {
            this.map.removeObject(this.boundary);
        }
    }
};
</script>
<style lang="scss">
.price-info {
    display: none;
    position: absolute;
    z-index: 2;
    width: 200px;
    background: #fff;
    color: #333;
    padding: 10px;
    box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.1);
    left: 50%;
    transform: translate(-50%, calc(-100% - 10px));
    top: 0;
    text-align: left;
    h4 {
        margin-top: 0;
        margin-bottom: 10px;
    }
    &:after {
        content: '';
        border: 10px solid #fff;
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        position: absolute;
        z-index: 2;
        left: 50%;
        bottom: -20px;
        transform: translate(-50%, 0);
    }
}
.marker-aggre .marker-shape {
    &:hover {
        .price-info {
            display: block;
        }
    }
}
</style>
